module.exports = __webpack_public_path__ + "fonts/NespressoLucas-SemiBdItalic.woff?v=ea3e38ed5a5a842d7a24941ad42d7df3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-SemiBdItalic.woff
// module id = 679
// module chunks = 0